import { galWhole } from "./overview";
import type { DayPickup, DayPickups } from "./api";
import type { SortColumn } from "./sort";

export const PICKUP_SOURCE_TEXT: Record<DayPickup["source"], string> = { screen: "App", import: "Sheet", seed: "Demo seed" };

/** "App, from a visit", "App", "Sheet" or "Demo seed". */
export function pickupSource(pickup: DayPickup): string {
  const source = PICKUP_SOURCE_TEXT[pickup.source] ?? pickup.source;
  return pickup.visit_id ? `${source}, from a visit` : source;
}

export const DAY_PICKUP_COLUMNS: SortColumn<DayPickup>[] = [
  { key: "account", label: "Account", value: (p) => p.number },
  { key: "raw", label: "Raw", value: (p) => p.raw_gal, first: "desc", num: true },
  { key: "scrap", label: "Scrap", value: (p) => p.scrap_gal, first: "desc", num: true },
  { key: "source", label: "Source", value: (p) => pickupSource(p) },
  { key: "recorded", label: "Recorded", value: (p) => p.recorded_at, first: "desc" },
];

/** "12 pickups: 1,301 gal raw, 210 gal scrap." with a note when the list is cut. */
export function pickupsSummary(found: DayPickups): string {
  if (found.count === 0) return "No pickup on this day.";
  const head = `${found.count.toLocaleString("en-US")} ${found.count === 1 ? "pickup" : "pickups"}: ${galWhole(found.raw_gal)} raw, ${galWhole(found.scrap_gal)} scrap.`;
  return found.count > found.pickups.length ? `${head} The list shows the first ${found.pickups.length.toLocaleString("en-US")}, by account.` : head;
}
